<script lang="ts">
    import { colors, activeColor } from "$lib/data";
    import tippy from "sveltejs-tippy";

    export let episode: number;

    const placement = "bottom";
    const facebook = {
        content: "Share on Facebook",
        placement,
    };

    let copied: boolean = false;

    const copy_link = async (url?: string) => {
        if (!navigator.clipboard || !url) return;
        try {
            await navigator.clipboard.writeText(url);
            copied = true;
            setTimeout(async () => {
                copied = false;
            }, 3500);
        } catch (err) {
            console.error("Failed to copy!", err);
        }
    };

    const twitter = {
        content: "Copy Link",
        placement,
    };

    const pinterest = {
        content: "Share on Pinterest",
        placement,
    };

    const email = {
        content: "Share via Email",
        placement,
    };
</script>

<div
    class="share"
    style="
        --primary: {colors[$activeColor].color};
        --secondary: {colors[$activeColor].highlight};
    "
>
    <h4>SHARE EPISODE #{episode}</h4>
    <div class="icons">
        <a
            href="https://www.facebook.com/sharer/sharer.php?u=https://craftroulette.live/episodes/episode-{episode}"
            use:tippy={facebook}
            class="facebook"
            target="_blank"
            rel="noopener noreferrer"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 310 310"
                style="enable-background:new 0 0 310 310;"
                xml:space="preserve"
            >
                <g id="XMLID_834_">
                    <path
                        id="XMLID_835_"
                        d="M81.703,165.106h33.981V305c0,2.762,2.238,5,5,5h57.616c2.762,0,5-2.238,5-5V165.765h39.064
                        c2.54,0,4.677-1.906,4.967-4.429l5.933-51.502c0.163-1.417-0.286-2.836-1.234-3.899c-0.949-1.064-2.307-1.673-3.732-1.673h-44.996
                        V71.978c0-9.732,5.24-14.667,15.576-14.667c1.473,0,29.42,0,29.42,0c2.762,0,5-2.239,5-5V5.037c0-2.762-2.238-5-5-5h-40.545
                        C187.467,0.023,186.832,0,185.896,0c-7.035,0-31.488,1.381-50.804,19.151c-21.402,19.692-18.427,43.27-17.716,47.358v37.752H81.703
                        c-2.762,0-5,2.238-5,5v50.844C76.703,162.867,78.941,165.106,81.703,165.106z"
                    />
                </g>
            </svg>
        </a>
        <button
            on:click={() =>
                copy_link(
                    `https://craftroulette.live/episodes/episode-${episode}`
                )}
            use:tippy={twitter}
            class="twitter"
            target="_blank"
            rel="noopener noreferrer"
            class:copied
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"
                ><rect width="256" height="256" fill="none" /><path
                    d="M131.88,192l-9.94,9.94a48,48,0,0,1-67.88-67.88L78.17,110A48,48,0,0,1,144,108"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="25"
                /><path
                    d="M124.12,64l9.94-9.94a48,48,0,0,1,67.88,67.88l-24.11,24.11A48,48,0,0,1,112,148"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="25"
                /></svg
            >
        </button>
        <a
            href="https://pinterest.com/pin/create/button/?url=https://craftroulette.live/episodes/episode-{episode}&description=Craft Roulette Episode {episode}"
            use:tippy={pinterest}
            class="pinterest"
            target="_blank"
            rel="noopener noreferrer"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 20 20"
                xml:space="preserve"
            >
                <path
                    d="M8.617 13.227C8.091 15.981 7.45 18.621 5.549 20c-.586-4.162.861-7.287 1.534-10.605-1.147-1.93.138-5.812 2.555-4.855 2.975 1.176-2.576 7.172 1.15 7.922 3.891.781 5.479-6.75 3.066-9.199C10.369-.275 3.708 3.18 4.528 8.245c.199 1.238 1.478 1.613.511 3.322-2.231-.494-2.897-2.254-2.811-4.6.138-3.84 3.449-6.527 6.771-6.9 4.201-.471 8.144 1.543 8.689 5.494.613 4.461-1.896 9.293-6.389 8.945-1.218-.095-1.728-.699-2.682-1.279z"
                />
            </svg>
        </a>
        <a
            href="mailto:?subject=Craft Roulette Episode #{episode}&amp;body=Check out this episode https://craftroulette.live/episodes/episode-{episode}"
            class="email"
            use:tippy={email}
            target="_blank"
            rel="noopener noreferrer"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                xml:space="preserve"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                /><polyline points="22,6 12,13 2,6" />
            </svg>
        </a>
    </div>
</div>

<style>
.share {
  padding: 0 1.7rem 2rem 1.7rem;
  min-width: 0;
}
.share h4 {
  font-size: 0.75rem;
  color: var(--offDark);
}
.share .icons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
}
.share .icons a, .share .icons button {
  border: none;
  width: 100%;
  height: 100%;
  max-width: 3rem;
  background: radial-gradient(circle, rgb(220, 234, 240) 0%, rgb(240, 245, 247) 100%);
  display: inline-grid;
  place-content: center;
  border-radius: 50%;
  aspect-ratio: 1;
}
.share .icons a svg, .share .icons button svg {
  width: 1.3rem;
  height: 1.3rem;
  fill: var(--secondary);
  color: var(--secondary);
}
.share .icons a:hover svg, .share .icons button:hover svg {
  fill: white;
  color: white;
}
.share .icons a.email svg {
  stroke: var(--secondary);
  fill: transparent;
}
.share .icons a.facebook:hover {
  background: #4267B2;
}
.share .icons a.pinterest:hover {
  background: #E60023;
}
.share .icons a.email:hover {
  background: #2B3990;
}
.share .icons a.email:hover svg {
  stroke: white !important;
  fill: transparent;
}
.share .icons button:hover {
  background: #0049B7;
}
.share .icons button.copied.twitter:hover {
  background: #00DDFF;
}
</style>
